import { createContext } from 'react'

import type { UseAccordionProviderReturn } from './use-accordion'

export type AccordionContext = UseAccordionProviderReturn

export const AccordionContext = createContext<AccordionContext>({
  size: 'md',
})
